// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rewardsBreakdownCardStyles } from "@rc/App/Components/RewardsBreakdownCard/RewardsBreakdownCard";
import { color, xScreen } from "@rc/XDL/Utilities";
import { css } from "styled-components";

rewardsBreakdownCardStyles.cardContainer = {
    css: css`
        max-width: 418px;
        width: 100%;
        border: 1px solid ${color("common.border")};
        display: flex;
        align-items: center;
        max-height: 78px;

        ${xScreen("lte", "md")} {
            max-width: calc(50% - 11px);
        }

        ${xScreen("lte", "sm")} {
            max-width: 100%;
            max-height: 100%;
        }
    `,
};

rewardsBreakdownCardStyles.detailsContainer = {
    css: css`
        padding: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1;
        gap: 8px;

        ${xScreen("lte", "sm")} {
            flex-direction: column;
            align-items: flex-start;
        }
    `,
};

rewardsBreakdownCardStyles.title = {
    variant: "h6",
    css: css`
        color: ${color("primary")};
        margin-bottom: 0;
        max-width: 100%;

        ${xScreen("gt", "sm")} {
            max-width: 155px;
        }
    `,
};

rewardsBreakdownCardStyles.value = {
    variant: "h2",
    css: css`
        margin-bottom: 0;
    `,
};

rewardsBreakdownCardStyles.iconWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 76px;
        max-height: 76px;
        width: 100%;
        height: 100%;
        background-color: ${color("common.ui8")};

        ${xScreen("lte", "sm")} {
            max-height: 100%;
        }
    `,
};

rewardsBreakdownCardStyles.icon = {
    css: css`
        width: 52px;
        height: 41px;

        svg {
            width: 52px;
            height: 41px;
        }
    `,
};
